"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PercentCompleteFieldLogic = void 0;
const types_1 = require("@smartsuite/types");
const clipboard_1 = require("../../utils/clipboard");
const google_sheet_1 = require("../../utils/google-sheet");
const migration_1 = require("../../utils/migration");
const detailed_decimal_1 = require("../../formatters/detailed-decimal");
const intl_1 = require("../../locale/intl");
const percent_complete_fieldtype_1 = require("../../safe-field-value/numder-fields/percent-complete-field/percent-complete.fieldtype");
const number_1 = require("../../utils/number");
const validation_1 = require("../../validation");
const base_number_fieldtype_1 = require("../base-fields/base-number.fieldtype");
const texts_1 = require("../../texts");
const percent_complete_model_1 = require("./percent-complete.model");
const validation_2 = require("../../validation/validation");
class PercentCompleteFieldLogic extends base_number_fieldtype_1.BaseNumberFieldLogic {
    constructor() {
        super(...arguments);
        this.name = "percentcompletefield";
        this.label = (0, intl_1.$t)(texts_1.percentCompleteFieldText.percent_complete);
        this.icon = "progress";
        this.iconColor = "#EC506E";
        this.placeholder = (0, intl_1.$t)(texts_1.percentCompleteFieldText.enter_number_here);
        this.searchSynonyms = [
            (0, intl_1.$t)(texts_1.percentCompleteFieldText.progress),
            (0, intl_1.$t)(texts_1.percentCompleteFieldText.done),
        ];
        this.isNumber = true;
        this.groupByMode = "card";
        this.fieldValueGetter = new percent_complete_fieldtype_1.PercentCompleteFieldValueGetter();
        // @ts-expect-error: Need to resolve
        this.clipboardPasteRules = {
            autonumberfield: clipboard_1.clipboardTextToSlider,
            countfield: clipboard_1.clipboardTextToSlider,
            currencyfield: clipboard_1.clipboardTextToSlider,
            numberfield: clipboard_1.clipboardTextToSlider,
            numbersliderfield: clipboard_1.clipboardTextToSlider,
            percentcompletefield: clipboard_1.clipboardSliderToSelf,
            percentfield: clipboard_1.clipboardTextToSlider,
            ratingfield: clipboard_1.clipboardTextToSlider,
            rollupfield: clipboard_1.clipboardTextToSlider,
            votefield: clipboard_1.clipboardTextToSlider,
            textfield: clipboard_1.clipboardTextToSlider,
            recordtitlefield: clipboard_1.clipboardTextToSlider,
            unknownfield: clipboard_1.clipboardTextToSlider,
        };
    }
    get validators() {
        return { required: validation_2.required, integerNumberField: validation_1.integerNumberField, numberBetweenMinMaxValue: validation_1.numberBetweenMinMaxValue };
    }
    filterValueToString(filterValue, field, userPreferences) {
        return this.valueToString(filterValue, field, userPreferences);
    }
    valueToString(fieldValue = null, field, userPreferences) {
        if (fieldValue === null) {
            return "";
        }
        const formatted = this.getFormattedValue(fieldValue, field, userPreferences);
        return `${formatted}%`;
    }
    getAggregateDisplayValue(fieldValue, field, userPreferences) {
        var _a, _b;
        if (!fieldValue) {
            return "";
        }
        const formattedValue = (0, detailed_decimal_1.convertNumberToFormatedString)({
            value: fieldValue,
            precision: 1,
            decimalSeparator: (0, number_1.getDecimalSeparator)((_a = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.locale) === null || _a === void 0 ? void 0 : _a.value),
            thousandSeparator: (0, number_1.getGroupSeparator)((_b = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.locale) === null || _b === void 0 ? void 0 : _b.value),
        });
        return `${formattedValue} %`.trim();
    }
    valueToGoogleSheet(fieldValue, _field, _userPreferences) {
        if (fieldValue === null) {
            return (0, google_sheet_1.makeRowDataValues)(null, "numberValue");
        }
        const value = Number(fieldValue || 0) / 100;
        return (0, google_sheet_1.makeRowDataValues)(value, "numberValue");
    }
    valueToExcelExport(fieldValue, _field, _userPreferences, _record) {
        const value = (!fieldValue && fieldValue !== 0) || isNaN(Number(fieldValue))
            ? ""
            : String(Number(fieldValue) / 100);
        return {
            t: value ? "n" : "t",
            v: value,
        };
    }
    getFormattedValue(fieldValue, field, userPreferences) {
        var _a, _b, _c, _d;
        return (0, detailed_decimal_1.convertNumberToFormatedString)({
            value: fieldValue !== null && fieldValue !== void 0 ? fieldValue : "",
            precision: (_b = (_a = field.params) === null || _a === void 0 ? void 0 : _a.precision) !== null && _b !== void 0 ? _b : 0,
            decimalSeparator: (0, number_1.getDecimalSeparator)((_c = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.locale) === null || _c === void 0 ? void 0 : _c.value),
            thousandSeparator: (0, number_1.getGroupSeparator)((_d = userPreferences === null || userPreferences === void 0 ? void 0 : userPreferences.locale) === null || _d === void 0 ? void 0 : _d.value),
        });
    }
    isValueEmpty(fieldValue) {
        return !fieldValue && fieldValue !== 0;
    }
    isDefaultEmpty(field) {
        return this.isValueEmpty(field.params.default_value);
    }
    getInlineEditRules(field) {
        return {
            ...super.getInlineEditRules(field),
            deleteValueOnFirstKeypress: true,
        };
    }
    getInitialFieldValue(startValue, field, userPreferences) {
        return this.validateValue(field, startValue, true, userPreferences)
            ? +startValue
            : this.getEmptyValue();
    }
    getLinkedRecordFieldSmartWidth(_field) {
        return {
            defaultWidht: 110,
            minWidth: 60,
        };
    }
    migrateField(fieldTo, fieldFrom) {
        var _a;
        const displayFormats = [
            percent_complete_model_1.PercentCompleteDisplayFormat.small,
            percent_complete_model_1.PercentCompleteDisplayFormat.medium,
            percent_complete_model_1.PercentCompleteDisplayFormat.large,
        ];
        const migratedField = super.migrateField(fieldTo, fieldFrom);
        return (0, migration_1.migrateDisplayFormat)(migratedField, displayFormats, (_a = fieldTo.params.display_format) !== null && _a !== void 0 ? _a : "");
    }
    getDefaultValue(field) {
        var _a;
        return +((_a = field.params.default_value) !== null && _a !== void 0 ? _a : 0) || 0;
    }
    filterToRecordValue(filterValue, comparison, field) {
        if (comparison !== "is_equal_to" || !(0, number_1.isNumeric)(filterValue)) {
            throw new types_1.FilterToRecordValueConversionError(field, filterValue, comparison);
        }
        const value = Number(filterValue);
        if (value < 0 || value > 100) {
            throw new types_1.FilterToRecordValueConversionError(field, filterValue, comparison);
        }
        return value;
    }
    metricWidgetValueToString(fieldValue, field, userPreferences) {
        const numberValue = Number(fieldValue);
        return this.valueToString(numberValue, field, userPreferences);
    }
}
exports.PercentCompleteFieldLogic = PercentCompleteFieldLogic;
